const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB200"
    },
    d: "M148.91,364.574l39.04,131.815c2.516,8.493,11.44,13.34,19.935,10.824l134.092-39.714 c8.493-2.516,13.34-11.44,10.824-19.934l-39.04-131.815L148.91,364.574z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCA400"
    },
    points: "332.699,380.21 167.945,428.84 162.221,409.514 327.09,361.117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCA400"
    },
    points: "342.312,412.942 177.581,461.378 171.898,442.189 336.703,393.849  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M207.888,507.213l134.092-39.714c7.455-2.208,12.097-9.354,11.42-16.811l-3.132-10.663 l-164.684,48.368l2.368,7.998C190.469,504.883,199.395,509.729,207.888,507.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEBF00"
    },
    d: "M266.441,64.348c-3.965-13.501-18.256-21.303-31.757-17.338 c-13.501,3.965-21.303,18.256-17.338,31.757l-10.787-36.725c-3.965-13.501-18.256-21.303-31.757-17.338l0,0 c-13.501,3.965-21.303,18.256-17.338,31.757l-11.187-38.09C142.311,4.87,128.02-2.932,114.519,1.033l0,0 C101.018,4.999,93.216,19.289,97.182,32.79l11.33,38.577c-3.965-13.501-18.256-21.303-31.757-17.338S55.451,72.285,59.416,85.786 l57.73,196.561l-45.663-56.181c-8.875-10.919-25.071-12.592-35.991-3.717l0,0c-10.919,8.875-12.592,25.071-3.717,35.991 l58.981,72.566c69.179,75.944,159.649,41.907,159.649,41.907c54.005-15.861,85.213-73.025,69.352-127.029L266.441,64.348z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB200"
    },
    d: "M102.418,312.344l-58.981-72.566c-4.504-5.542-6.28-12.442-5.521-19.055 c-0.83,0.527-1.644,1.093-2.425,1.727l0,0c-10.919,8.875-12.592,25.071-3.717,35.991l58.981,72.566 c69.179,75.944,159.649,41.907,159.649,41.907c28.738-8.44,51.018-28.577,63.187-53.708c-12.702,16.239-30.35,28.827-51.526,35.046 C262.068,354.252,171.597,388.287,102.418,312.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB200"
    },
    d: "M114.519,1.033C101.018,4.999,93.216,19.289,97.182,32.79l11.33,38.577l44.2,150.496l19.873-5.837 l-44.2-150.496l-11.33-38.577c-2.927-9.967,0.571-20.351,8.028-26.706C121.639-0.219,118.054-0.005,114.519,1.033L114.519,1.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB200"
    },
    d: "M157.464,56.462l44.343,150.982l19.873-5.837L177.337,50.624 c-2.927-9.967,0.571-20.351,8.028-26.706c-3.443-0.466-7.029-0.253-10.563,0.785C161.301,28.67,153.498,42.96,157.464,56.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB200"
    },
    d: "M234.684,47.011c-13.501,3.965-21.303,18.256-17.338,31.757l33.557,114.257l19.873-5.837 L237.219,72.932c-2.927-9.967,0.571-20.351,8.028-26.706C241.803,45.759,238.218,45.972,234.684,47.011L234.684,47.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DDB200"
    },
    d: "M188.475,265.412c-14.208-9.786-33.403-16.488-58.143-12.075L79.29,79.953 c-2.934-9.965,0.558-20.351,8.011-26.711c-3.443-0.464-7.029-0.248-10.563,0.793l0,0c-13.499,3.973-21.292,18.27-17.317,31.769 l57.855,196.524c0,0,27.244-12.55,62.861-1.551c0,0,4.112,1.201,6.329,0.549c4.639-1.366,7.293-6.234,5.928-10.873 C191.6,267.755,188.475,265.412,188.475,265.412z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M288.559,358.485V495.96c0,8.858,7.181,16.04,16.04,16.04h139.85c8.858,0,16.04-7.181,16.04-16.04 V358.485H288.559z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288.557,
    y: 405.395,
    style: {
      fill: "#EEBF00"
    },
    width: 171.93,
    height: 19.898
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.557,
    y: 439.502,
    style: {
      fill: "#EEBF00"
    },
    width: 171.93,
    height: 19.898
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3F62"
    },
    d: "M288.559,495.96c0,8.858,7.181,16.04,16.04,16.04h139.85c8.858,0,16.04-7.181,16.04-16.04v-8.328 H288.559V495.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEB99"
    },
    d: "M485.925,103.561c0-14.072-11.513-25.584-25.584-25.584c-14.071,0-25.584,11.513-25.584,25.584 V65.284c0-14.072-11.513-25.584-25.584-25.584l0,0c-14.072,0-25.584,11.513-25.584,25.584v-39.7C383.587,11.513,372.073,0,358.003,0 l0,0c-14.072,0-25.584,11.513-25.584,25.584V65.79c0-14.072-11.513-25.584-25.584-25.584c-14.072,0-25.584,11.513-25.584,25.584 v204.863l-27.981-66.772c-5.438-12.978-20.507-19.147-33.485-13.708l0,0c-12.978,5.438-19.146,20.507-13.708,33.485l36.142,86.245 c44.975,92.36,141.37,85.198,141.37,85.198c56.286,0,102.338-46.052,102.338-102.338V103.561H485.925z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M258.664,295.284l-36.142-86.245c-2.76-6.586-2.519-13.707,0.073-19.838 c-0.945,0.272-1.885,0.586-2.813,0.975l0,0c-12.978,5.438-19.146,20.507-13.708,33.485l36.142,86.245 c44.975,92.36,141.37,85.198,141.37,85.198c29.952,0,57.003-13.042,75.762-33.726c-16.764,12.002-37.243,19.105-59.313,19.105 C400.035,380.482,303.639,387.645,258.664,295.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M358.003,0c-14.072,0-25.584,11.513-25.584,25.584V65.79v156.852h20.713V65.791V25.584 c0-10.387,6.283-19.365,15.228-23.362C365.186,0.805,361.686,0,358.003,0L358.003,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M383.587,65.284v157.359h20.713V65.284c0-10.387,6.283-19.365,15.228-23.361 c-3.172-1.418-6.672-2.223-10.356-2.223C395.1,39.699,383.587,51.212,383.587,65.284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M460.34,77.976c-14.072,0-25.584,11.513-25.584,25.584v119.083h20.713V103.561 c0-10.387,6.283-19.365,15.228-23.361C467.524,78.781,464.025,77.976,460.34,77.976L460.34,77.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M423.335,359.38c-2.513,0-4.98-1.205-6.496-3.441c-2.432-3.584-1.497-8.461,2.087-10.892 c17.401-11.803,27.789-31.347,27.789-52.283c0-4.332,3.511-7.842,7.842-7.842c4.331,0,7.842,3.51,7.842,7.842 c0,26.139-12.96,50.537-34.668,65.263C426.382,358.942,424.85,359.38,423.335,359.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M354.327,274.536c-10.866-13.4-27.387-25.25-52.366-28.004V65.791 c0-10.387,6.283-19.365,15.228-23.362c-3.172-1.418-6.672-2.223-10.356-2.223l0,0c-14.072,0-25.584,11.513-25.584,25.585v204.863 c0,0,29.68-4.346,60.741,16.264c0,0,3.605,2.314,5.916,2.314c4.836,0,8.757-3.921,8.757-8.757 C356.663,277.666,354.327,274.536,354.327,274.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubber);
export default __webpack_public_path__ + "static/media/Rubber.c65860b316538960e2f892ad14db22cc.svg";
export { ForwardRef as ReactComponent };